import styled from 'styled-components';
export const Button = styled.button `
  background-color: transparent;
  border: none;
  cursor: pointer;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  outline: none;
  color: var(--color-neutral-130);

  :hover {
    color: var(--link-color-main-hover);
  }

  :focus {
    outline: var(--border-width-thin) solid var(--color-neutral-130);
    border-radius: var(--border-radius-xxs);
  }
`;
